import { api } from "@/lib/api";

// Sprint 9 — Library
export const LibraryAPI = {
  // books
  books: (params) => api.get("/library/books", { params }).then((r) => r.data),
  createBook: (body) => api.post("/library/books", body).then((r) => r.data),
  updateBook: (id, patch) => api.patch(`/library/books/${id}`, patch).then((r) => r.data),
  removeBook: (id) => api.delete(`/library/books/${id}`).then((r) => r.data),
  // settings
  settings: (institution_id) => api.get("/library/settings", { params: { institution_id } }).then((r) => r.data),
  saveSettings: (body) => api.put("/library/settings", body).then((r) => r.data),
  // loans
  loans: (params) => api.get("/library/loans", { params }).then((r) => r.data),
  issue: (body) => api.post("/library/loans", body).then((r) => r.data),
  returnLoan: (lid) => api.post(`/library/loans/${lid}/return`).then((r) => r.data),
  markPaid: (lid) => api.post(`/library/loans/${lid}/mark-paid`).then((r) => r.data),
  dashboard: () => api.get("/library/dashboard").then((r) => r.data),
};
